<template>
  <div class="form-control">
    <v-layout row wrap>
      <v-flex xs12 sm6 class="pr-2 pb-2">
        <div class="form-control">
          <div class="primary--text caption">{{ $t('company') }}</div>
          <div>
            <multiselect
              v-model="filter.gpf_company_code"
              :options="gpfCompanyOptions"
              :allow-empty="true"
              :searchable="true"
              :openDirection="'bottom'"
              selectLabel
              selectedLabel
              deselect-label
              track-by="company_code"
              label="company_name"
              :multiple="true"
              :placeholder="$t('All')"
            ></multiselect>
          </div>
        </div>
      </v-flex>
      <v-flex xs12 sm6 class="pl-2 pb-2">
        <div class="form-control">
          <div class="primary--text caption">{{ $t('work_group') }}</div>
          <div>
            <multiselect
              :disabled="!filter.gpf_company_code || filter.gpf_company_code.length === 0"
              v-model="filter.gpf_group_code"
              :options="gpfGroupOptions"
              :allow-empty="true"
              :searchable="true"
              :openDirection="'bottom'"
              selectLabel
              selectedLabel
              deselect-label
              track-by="group_code"
              label="group_name"
              :multiple="true"
              :placeholder="$t('All')"
            ></multiselect>
          </div>
        </div>
      </v-flex>
      <v-flex xs12 sm6 class="pr-2 pb-2">
        <div class="form-control">
          <div class="primary--text caption">{{ $t('department') }}</div>
          <div>
            <multiselect
              :disabled="!filter.gpf_company_code || filter.gpf_company_code.length === 0"
              v-model="filter.gpf_department_code"
              :options="gpfDepartmentOptions"
              :allow-empty="true"
              :searchable="true"
              :openDirection="'bottom'"
              selectLabel
              selectedLabel
              deselect-label
              track-by="department_code"
              label="department_name"
              :multiple="true"
              :placeholder="$t('All')"
            ></multiselect>
          </div>
        </div>
      </v-flex>
      <v-flex xs12 sm6 class="pl-2 pb-2">
        <div class="form-control">
          <div class="primary--text caption">{{ $t('position') }}</div>
          <div>
            <multiselect
              :disabled="!filter.gpf_company_code || filter.gpf_company_code.length === 0"
              v-model="filter.gpf_position_code"
              :options="gpfPositionOptions"
              :allow-empty="true"
              :searchable="true"
              :openDirection="'bottom'"
              selectLabel
              selectedLabel
              deselect-label
              track-by="position_code"
              label="position_name"
              :multiple="true"
              :placeholder="$t('All')"
            ></multiselect>
          </div>
        </div>
      </v-flex>
      <v-flex xs6 class="pr-2">
        <div class="form-control">
          <div class="primary--text caption">{{ $t('gpf_year') }}</div>
          <div>
            <multiselect
              v-model="filter.gpf_years"
              :options="gpfYearOptions"
              :allow-empty="true"
              :searchable="false"
              :openDirection="'bottom'"
              selectLabel
              selectedLabel
              deselect-label
              :placeholder="$t('All')"
              :multiple="true"
            ></multiselect>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  props: ['value'],
  components: {
    Multiselect
  },
  data() {
    return {
      filter: this.value,
      gpfYearOptions: ['ก่อน พ.ศ.2555', 'หลัง พ.ศ.2555']
    }
  },
  mounted() {
    this.handleInitialGpfBuddy()
  },
  computed: {
    gpfBuddyMasterData() {
      return this.$store.state.gpfBuddyMasterData || []
    },
    gpfCompanyOptions() {
      const tempMapCompany = this.gpfBuddyMasterData.companies
        ? this.gpfBuddyMasterData.companies.map((el) => {
            return {
              company_code: el.company_code,
              company_name: `${el.company_code} - ${el.company_name}`
            }
          })
        : []
      return [...tempMapCompany] || []
    },
    gpfGroupOptions() {
      const allGroups = this.gpfBuddyMasterData.groups
      let tempOptions = []
      let tempResult = []

      if (this.filter.gpf_company_code && this.filter.gpf_company_code.length > 0) {
        const selectedCompanyCode = this.filter.gpf_company_code.map((el) => el.company_code)
        tempResult = allGroups.filter((el) => {
          return [...selectedCompanyCode].includes(el.company_code)
        })
      } else {
        tempResult = allGroups
      }

      tempResult.forEach((el) => {
        let companyName = this.getCompanyName(el.company_code)
        if (!tempOptions.some((item) => item.group_code === el.group_code)) {
          tempOptions.push({
            group_code: el.group_code,
            group_name: `(${companyName}) - (${el.group_code}) ${el.group_name}`
          })
        }
      })

      return tempOptions
    },
    gpfDepartmentOptions() {
      const allDepartments = this.gpfBuddyMasterData.departments
      let tempOptions = []
      let tempResult = []

      if (this.filter.gpf_company_code && this.filter.gpf_company_code.length > 0) {
        const selectedCompanyCode = this.filter.gpf_company_code.map((el) => el.company_code)

        const tempFilterDepartments = allDepartments.filter((el) => {
          return [...selectedCompanyCode].includes(el.company_code)
        })

        tempResult = tempFilterDepartments

        if (this.filter.gpf_group_code && this.filter.gpf_group_code.length > 0) {
          let selectedGroupCode = this.filter.gpf_group_code.map((el) => el.group_code)
          tempResult = tempFilterDepartments.filter((el) => {
            return [...selectedGroupCode].includes(el.group_code)
          })
        }
      } else {
        tempOptions = allDepartments
      }

      tempResult.forEach((el) => {
        let companyName = this.getCompanyName(el.company_code)
        if (!tempOptions.some((item) => item.department_code === el.department_code)) {
          tempOptions.push({
            department_code: el.department_code,
            department_name: `(${companyName}) - (${el.department_code}) ${el.department_name}`
          })
        }
      })

      return tempOptions
    },
    gpfPositionOptions() {
      const allPositions = this.gpfBuddyMasterData.positions
      let tempOptions = []
      let tempResult = []

      if (this.filter.gpf_company_code && this.filter.gpf_company_code.length > 0) {
        let tempFilterPositions = []
        const selectedCompanyCode = this.filter.gpf_company_code.map((el) => el.company_code)
        tempFilterPositions = allPositions.filter((el) => {
          return [...selectedCompanyCode].includes(el.company_code)
        })

        tempResult = tempFilterPositions

        if (this.filter.gpf_group_code && this.filter.gpf_group_code.length > 0) {
          const selectedGroupCode = this.filter.gpf_group_code.map((el) => el.group_code)
          tempResult = tempFilterPositions.filter((el) => {
            return [...selectedGroupCode].includes(el.group_code)
          })
        }

        if (this.filter.gpf_department_code && this.filter.gpf_department_code.length > 0) {
          const selectedDepartmentCode = this.filter.gpf_department_code.map(
            (el) => el.department_code
          )
          tempResult = tempFilterPositions.filter((el) => {
            return [...selectedDepartmentCode].includes(el.department_code)
          })
        }
      } else {
        tempResult = allPositions
      }

      tempResult.forEach((el) => {
        let companyName = this.getCompanyName(el.company_code)
        if (!tempOptions.some((item) => item.position_code === el.position_code)) {
          tempOptions.push({
            position_code: el.position_code,
            position_name: `(${companyName}) - (${el.position_code}) ${el.position_name}`
          })
        }
      })

      return tempOptions
    }
  },
  methods: {
    handleInitialGpfBuddy() {
      const vm = this
      try {
        const gpfBuddyData = vm.gpfBuddyMasterData
        const companies = gpfBuddyData.companies
        const groups = gpfBuddyData.groups
        const departments = gpfBuddyData.departments
        const positions = gpfBuddyData.positions

        if (vm.filter.gpf_company_code) {
          const selectedCompany = companies
            .filter((el) => {
              return el.company_code === vm.filter.gpf_company_code
            })
            .map((el) => {
              return {
                company_code: el.company_code,
                company_name: `${el.company_code} - ${el.company_name}`
              }
            })

          vm.$set(vm.filter, 'gpf_company_code', ...selectedCompany)

          const selectedCompanyCode = vm.filter.gpf_company_code.map((el) => el.company_code)
          if (vm.filter.gpf_group_code) {
            const selectedGroup = groups
              .filter((el) => {
                // return el.company_code === selectedCompanyCode
                return [...selectedCompanyCode].includes(el.company_code)
              })
              .map((el) => {
                let companyName = this.getCompanyName(el.company_code)
                return {
                  group_code: el.group_code,
                  group_name: `(${companyName}) - (${el.group_code}) ${el.group_name}`
                }
              })

            // const selectedGroup = groupByCompany.find((el) => {
            //   return el.group_code === vm.filter.gpf_group_code
            // })

            vm.$set(vm.filter, 'gpf_group_code', selectedGroup)
          }

          if (vm.filter.gpf_department_code) {
            const selectedDepartment = departments
              .filter((el) => {
                // return el.company_code === selectedCompanyCode
                return [...selectedCompanyCode].includes(el.company_code)
              })
              .map((el) => {
                let companyName = this.getCompanyName(el.company_code)
                return {
                  department_code: el.department_code,
                  department_name: `(${companyName}) - (${el.department_code}) ${el.department_name}`
                }
              })

            // const selectedDepartment = departmentByCompany.find(
            //   (el) => el.department_code == vm.filter.gpf_department_code
            // )

            vm.$set(vm.filter, 'gpf_department_code', selectedDepartment)
          }

          if (vm.filter.gpf_position_code) {
            const selectedPosition = positions
              .filter((el) => {
                // return el.company_code === selectedCompanyCode
                return [...selectedCompanyCode].includes(el.company_code)
              })
              .map((el) => {
                let companyName = this.getCompanyName(el.company_code)
                return {
                  position_code: el.position_code,
                  position_name: `(${companyName}) - (${el.position_code}) ${el.position_name}`
                }
              })

            // const selectedPosition = positionByCompany.find(
            //   (el) => el.position_code == vm.filter.gpf_position_code
            // )

            vm.$set(vm.filter, 'gpf_position_code', selectedPosition)
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    getCompanyName(companyCode) {
      const companies = this.gpfBuddyMasterData.companies
      const foundCompany = companies.find((el) => el.company_code === companyCode)
      return foundCompany ? foundCompany.company_name : ''
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/GpfBuddy/BroadcastFilterCustomer.vue